import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useItemIdParam } from './components/commons';
import { useSelector } from 'react-redux';
import { 
  selectItemDetails, 
  selectItemIsLoaded,
  selectIsLoggedIn,
} from './ducks';

export const useNoboScript = () => {
  const location = useLocation();
  const [img, setImg] = useState(null);
  const [csFpid, setCsFpid] = useState('');
  const itemIsLoaded = useSelector(selectItemIsLoaded);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { id, nopreroll, nsfw, media } = useSelector(selectItemDetails);
  const itemIdParam = useItemIdParam();
  const isVideoItem = (media || []).some(x => x.mediatype === 'VIDEO');
  const showAds = nopreroll || nsfw ? 0 : 1;

  const parseVideoDuration = (value) => {
    switch (typeof value) {
    case 'number':
      return value;
    case 'string':
      return value.split(':').reverse().map(k => parseInt(k)).reduce((a, b, i) => a + b * Math.pow(60, i));
    }
  };

  const sendNoboTags = useCallback((opts) => {
    const tags = {
      c1: '2',
      c2: '12344628',
      c4: '',
      c7: encodeURIComponent(window.location),
      ns_site: 'total',
      nmo_02: !itemIdParam ? 1 : 0,
      nmo_05: 0,
      nmo_10: isLoggedIn ? 1 : 0,
      cs_fpid: csFpid,
    };
    if (itemIdParam && isVideoItem && opts.videoId) {
      Object.assign(tags, {
        nmo_30: 1,
        nmo_31: 0,
        nmo_32: parseVideoDuration(opts.videoDuration),
        nmo_33: 1300,
        nmo_38: 'Mediahuis',
        nmo_39: 'Mediahuis',
      });
    }

    if (img) {
      const qs = Object.entries(tags).flatMap(x => x.join('=')).join('&');
      img.src = 'https://sb.scorecardresearch.com/b?' + qs;
    }
  }, [img, isVideoItem, itemIdParam, showAds]);

  const handleAgnoplayerEvent = useCallback((event) => {
    const { data, videoId } = event.data;
    switch (data.type) {
    case 'contentPlay':
      sendNoboTags({ videoCategory: 121, videoDuration: data.duration, videoId: videoId }); break;
    default:
      break;
    }
  }, [sendNoboTags]);

  useEffect(() => {
    setImg(document.createElement('img'));
  }, []);

  useEffect(() => {
    window.receiveAgnoplayEvent = (event) => handleAgnoplayerEvent(event);
  }, [handleAgnoplayerEvent]);

  useEffect(() => {
    let cs_fpid = window.sessionStorage.getItem('cs_fpid');
    if(!cs_fpid) {
      cs_fpid = [+new Date(), Math.floor(Math.random() * 99999999 + 1000000)].join('_');
      window.sessionStorage.setItem('cs_fpid', cs_fpid);
    }
    setCsFpid(cs_fpid);
    if (!itemIdParam || itemIsLoaded && itemIdParam === id) {
      sendNoboTags({ videoCategory: '', videoDuration: (media || [{}])[0].duration });
    }
  }, [img, itemIdParam, itemIsLoaded, isVideoItem, id, location.pathname, isLoggedIn, sendNoboTags]);
};